import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// หมายเหตุ: 
// - Development: ใช้ proxy จาก package.json (http://localhost:7100)
// - Production: ใช้ Netlify proxy redirects ใน _redirects (/api/* -> Railway)
//   ไม่ต้องตั้งค่า REACT_APP_API_URL เพราะใช้ relative path (/api/...)

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

